// src/CardForm.js
import React from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import styled from "styled-components";

const CardFormWrapper = styled.div`
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const StyledCardElement = styled(CardElement)`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #fafafa;
  font-size: 16px;
`;

const SubmitButton = styled.button`
  background-color: #6772e5;
  color: #fff;
  padding: 10px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:disabled {
    background-color: #bbb;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background-color: #5469d4;
  }
`;

const CardForm = ({ onCardSubmit }) => {
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    const cardElement = elements.getElement(CardElement);
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
    });

    if (error) {
      console.error("[error]", error);
    } else {
      onCardSubmit(paymentMethod.id);
    }
  };

  return (
    <CardFormWrapper>
      <Form onSubmit={handleSubmit}>
        <StyledCardElement />
        <SubmitButton type="submit" disabled={!stripe}>
          Update Payment Method
        </SubmitButton>
      </Form>
    </CardFormWrapper>
  );
};

export default CardForm;
